import { AuthService } from './../../shared/models/auth.service';
import { SVGdriverModel, SharedVehicleGroupDriverModel } from './../models/driver.model';
import { TranslateService } from './../../shared/translate/translate.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { DriverService } from '../models/driver.service';
import { SharedVehicleGroupModel } from '../../sharedvehiclegroup/models/sharedvehiclegroup.model';
import { SharedVehicleGroupService } from '../../sharedvehiclegroup/models/sharedvehiclegroup.service';

@Component({
  selector: 'wego-assign-driver-group-popup',
  template: require('../views/assign-driver-group-popup.component.html'),
})

export class AssignDriverGroupPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  sharedVehicleGroupList: SharedVehicleGroupDriverModel[];
  subscriptionHashId: string;
  message: string;
  apiErrorMsg: string;
  driverMasterHashId: string;
  isLoading: boolean;
  private popupMsg: string;
  private module: string;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('driverModal') public driverModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(private driverService: DriverService
    , private SVGService: SharedVehicleGroupService
    , private router: Router
    , private translate: TranslateService
    , private authService: AuthService) { }

  ngOnInit() {
    this.module = this.translate.instant('LblSharedVehicleGroup');
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["groupName", "organizationName"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetSVGListForDrivers();
    this.driverModal.show();
    this.subscriptionHashId = '';
  }

  public hide(): void {
    this.driverModal.hide();
  }

  private GetSVGListForDrivers() {
    this.isLoading = true;
    this.SVGService.GetSVGListForDrivers(this.driverMasterHashId, this.DataListModel)
      .subscribe(
      res => {
        this.sharedVehicleGroupList = res.data;
        this.sharedVehicleGroupList.forEach(x => {          
          x.selectedOrganizationSubscription = x.listOfSubscription[0].organizationSubscriptionHashId;
        })
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }


  private select(sharedvehiclegroupHashId: string, organizationHashId: string): void {
    this.isLoading = true;
    let model = new SVGdriverModel();
    model.driverHashId = this.driverMasterHashId;
    model.sharedvehiclegroupHashId = sharedvehiclegroupHashId;
    
    let subsModel = this.sharedVehicleGroupList.find(x => x.organizationMasterHashId == organizationHashId &&  x.sharedvehiclegroupHashId==sharedvehiclegroupHashId);    
    model.organizationSubscriptionHashId = subsModel.selectedOrganizationSubscription;

    this.driverService.AssignSVGToDriver(model)
      .subscribe(
      res => {
        this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]);
        this.OnSuccessSelect();
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.driverModal.hide();
        this.isLoading = false;
      });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetSVGListForDrivers();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetSVGListForDrivers();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetSVGListForDrivers();
  };


  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetSVGListForDrivers();
  }

  private OnSuccessSelect() {
    this.onSuccessSelect.emit({ SuccessMessage: this.popupMsg })
  }
  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver/components/assign-driver-group-popup.component.ts